import { BaseDto } from './base.dto';

export class User extends BaseDto {
  username?: string;
  displayName?: string; // same as name
  email?: string;
  password?: string;
  phone?: string;
  role?: string;
  avatar?: string;
  jobTitle?: string;
  signature?: string;
  signatureName?: string;
  lastPasswordChange?: Date;
  isDisabled?: boolean;
  /** @deprecated Use UserPermissionOverride with key 'inspections.approve' instead */
  canApproveInspections?: boolean;
}
